import React, { Component } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Radio,
    TextField,
    Typography,
    Autocomplete,
    Tooltip,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import WorkIcon from '@mui/icons-material/Work';
import Auth from '../../utils/authenticate';
import Service from '../../config/networkutils';
import { withSnackbar } from 'notistack';



const token = Auth.token()

const formatRoleHeader = roleName => {
    const words = String(roleName || '').trim().split(/\s+/).filter(Boolean);
    if (words.length <= 2) return words.join(' ');

    return <>{words.slice(0, 2).join(' ')}<br />{words.slice(2).join(' ')}</>;
}

const fixedColumns = [
    { field: 'project_value', label: 'VALUE', stickyLeft: 88, width: 96, render: (value) => formatValue('project_value', value) },
    { field: 'project_type', label: 'Project Type', stickyLeft: 184, width: 180 },
    { field: 'descipline_name', label: 'Discipline', stickyLeft: 364, width: 180 }
];

const formatValue = (field, value) => {
    if (value === null || value === undefined || value === '') return '-';
    if (field === 'project_value') {
        return value + 'M';
    }
    if (field === 'updated_on') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? value : date.toLocaleString();
    }
    return value;
};

class ResourceProfileTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editingCell: null,
            editValue: '',
            editingRow: null,
            editProjectType: '',
            editProjectValue: '',
            deletingRowId: null,
            deleteConfirmationRow: null,
            workTypeData: this.props.workTypeData || [],
            workTypeDialogOpen: false,
            selectedWorkType: null,
            selectedRole: null,
            submittingWorkType: false,
            workTypeNamesByRole: {},
        };
    }

    componentDidUpdate(previousProps) {
        if (previousProps.workTypeData !== this.props.workTypeData) {
            this.setState({
                workTypeData: Array.isArray(this.props.workTypeData) ? this.props.workTypeData : [],
            });
        }

    }

    openWorkTypeDialog(role) {
        const existingWorkTypeName = String(role?.work_type_name || '').trim().toLowerCase();
        const selectedWorkType = existingWorkTypeName
            ? this.state.workTypeData.find(workType => (
                String(workType?.name || '').trim().toLowerCase() === existingWorkTypeName
            )) || null
            : null;

        this.setState({
            workTypeDialogOpen: true,
            selectedWorkType,
            selectedRole: role,
        });
    }

    closeWorkTypeDialog() {
        this.setState({
            workTypeDialogOpen: false,
            selectedWorkType: null,
            selectedRole: null,
        });
    }

    componentDidMount() {
        console.log(this.props);
    }

    submitWorkType() {
        const { selectedRole, selectedWorkType } = this.state;
        if (!selectedWorkType) {
            this.props.enqueueSnackbar('Please select a work type.', {
                variant: 'warning'
            });
            return;
        }

        this.setState({ submittingWorkType: true });
        const existingWorkTypeId = selectedRole?.work_type_id;
        const requestMethod = existingWorkTypeId !== undefined && existingWorkTypeId !== null
            ? 'patch'
            : 'post';
        const request = {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                ...(requestMethod === 'patch' && { id: existingWorkTypeId }),
                work_type: selectedWorkType.id,
                role: selectedRole?.id,
                stage_id: this.props.selectedStage?.id,
                division: this.props.selectedDivision?.id,
            }
        };
        const saveWorkType = requestMethod === 'patch'
            ? Service.patch('/api/resource/profile/work/type/edit_resource_profile_work_type/', request)
            : Service.post('/api/resource/profile/work/type/resource_profile_work_type_link/', request);

        saveWorkType
            .then(() => {
                if (selectedRole?.id !== undefined && selectedRole?.id !== null) {
                    this.setState(prevState => ({
                        workTypeNamesByRole: {
                            ...prevState.workTypeNamesByRole,
                            [String(selectedRole.id)]: selectedWorkType.name,
                        },
                    }));
                }
                this.props.enqueueSnackbar('Work type submitted successfully.', {
                    variant: 'success'
                });
                this.closeWorkTypeDialog();
            })
            .catch(error => {
                console.log(error);
                if (error.status === 400) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
            .finally(() => this.setState({ submittingWorkType: false }));
    }

    startRowEdit(row) {
        this.setState({
            editingRow: row,
            editProjectType: row.project_type || '',
            editProjectValue: row.project_value ?? '',
        });
    }

    saveRowEdit(event) {
        event.preventDefault();
        const row = this.state.editingRow;
        if (!row) return;

        const projectType = this.state.editProjectType.trim();
        const projectValue = String(this.state.editProjectValue).trim();
        if (!projectType || !projectValue) {
            this.props.enqueueSnackbar('Project type and value are required.', {
                variant: 'warning'
            });
            return;
        }

        Service.patch(`/api/resource/profile/project/type/update_resource_profile_project_type_data/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                id: row.id,
                project_type: projectType,
                project_value: projectValue,
            }
        })
            .then(() => {
                this.props.onRowUpdated(row.project_type_id, {
                    project_type: projectType,
                    project_value: projectValue,
                });
                if (this.props.onRefresh) this.props.onRefresh();
                this.setState({ editingRow: null });
                this.props.enqueueSnackbar('Resource profile row updated successfully!', {
                    variant: 'success'
                });
            }).catch(error => {
                console.log(error);
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    deleteRow(row) {
        const projectTypeId = row.project_type_id ?? row.id;
        if (row.is_deletable === false || projectTypeId === null || projectTypeId === undefined) return;

        this.setState({ deleteConfirmationRow: row });
    }

    confirmDeleteRow() {
        const row = this.state.deleteConfirmationRow;
        if (!row) return;

        const projectTypeId = row.project_type_id ?? row.id;
        this.setState({ deletingRowId: projectTypeId });
        Service.delete(`/api/resource/profile/project/type/delete_resource_profile_project_type_data/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                project_type: projectTypeId
            }
        })
            .then(() => {
                this.props.onRowDeleted(projectTypeId);
                this.setState({ deleteConfirmationRow: null });
                if (this.props.onRefresh) this.props.onRefresh();
                this.props.enqueueSnackbar('Resource profile row deleted successfully!', {
                    variant: 'success'
                });
            }).catch(error => {
                console.log(error);
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            }).finally(() => this.setState({ deletingRowId: null }));
    }

    handleQuantityEnter() {
        const { editingCell, editValue } = this.state;
        if (!editingCell) return;

        Service.post(`/api/resource/profile/role/quantity/create_or_update_resource_stage_demand_data/`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                ...(!editingCell.isCreating && { id: editingCell.quantityId }),
                project_type_id: editingCell.projectTypeId ?? null,
                role_id: editingCell.roleId ?? null,
                quantity: editValue ?? null,
            }
        })
            .then(() => {
                this.props.onQuantityUpdated(editingCell.rowId, editingCell.roleId, editValue);
                this.setState({ editingCell: null });
                if (this.props.onRefresh) this.props.onRefresh();
                this.props.enqueueSnackbar('Quantity updated successfully!', {
                    variant: 'success'
                });

            }).catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    render() {
        const rows = Array.isArray(this.props.data) ? this.props.data : [];
        const workTypeNamesByRole = rows.reduce((namesByRole, row) => {
            if (!Array.isArray(row.work_type)) return namesByRole;

            row.work_type.forEach(workType => {
                const roleId = workType?.role_id;
                const workTypeName = typeof workType?.work_type_name === 'string'
                    ? workType.work_type_name.trim()
                    : '';

                if (!roleId || !workTypeName || namesByRole[String(roleId)]) return;
                namesByRole[String(roleId)] = {
                    name: workTypeName,
                    id: workType.id,
                };
            });

            return namesByRole;
        }, {});

        const roles = (Array.isArray(this.props.rolesData) ? this.props.rolesData : []).map(role => ({
            ...role,
            work_type_name: this.state.workTypeNamesByRole[String(role.id)]
                || workTypeNamesByRole[String(role.id)]?.name
                || '',
            work_type_id: workTypeNamesByRole[String(role.id)]?.id,
        }));

        const columns = [
            this.props.importProfileView
                ? { field: 'select', label: '', stickyLeft: 0, width: 88 }
                : { field: 'actions', label: 'Actions', stickyLeft: 0, width: 88 },
            ...fixedColumns,
            ...roles.map(role => ({
                field: `role-${role.id}`,
                roleId: role.id,
                label: role.job_roles,
                workTypeName: role.work_type_name,
            })),
        ];

        return (
            <>
                <TableContainer component={Paper} sx={{ maxHeight: 520, borderRadius: 1, border: '1px solid #d7e1e8', boxShadow: '0 2px 8px rgba(15, 48, 71, 0.1)', transition: 'box-shadow 180ms ease', '&:hover': { boxShadow: '0 6px 18px rgba(15, 48, 71, 0.16)' }, '@media (prefers-reduced-motion: reduce)': { transition: 'none' } }}>
                    <Table stickyHeader size='small' aria-label='Resource profile table'>
                        <TableHead>
                            <TableRow sx={{ height: 72 }}>
                                {columns.map(column => (
                                    <TableCell
                                        key={column.field}
                                        sx={{
                                            backgroundColor: '#075e96',
                                            color: '#fff',
                                            fontWeight: 400,
                                            fontSize: 14,
                                            padding: '10px 16px',
                                            borderTop: '3px solid #4b9ac4',
                                            borderBottom: '2px solid #064d79',
                                            borderRight: '1px solid rgba(255, 255, 255, 0.18)',
                                            boxShadow: 'inset 0 1px 0 rgba(255, 255, 255, 0.12)',
                                            whiteSpace: 'nowrap',
                                            ...(column.stickyLeft !== undefined && {
                                                position: 'sticky',
                                                left: column.stickyLeft,
                                                zIndex: 3,
                                                width: column.width,
                                                minWidth: column.width,
                                                maxWidth: column.width,
                                            }),
                                        }}
                                    >
                                        {column.roleId !== undefined ? (
                                            (() => {
                                                const role = roles.find(item => String(item.id) === String(column.roleId));
                                                const workTypeName = role?.work_type_name;
                                                const roleHeader = (
                                                    <span style={{ textAlign: 'center' }}>{formatRoleHeader(column.label)}</span>
                                                );

                                                if (this.props.importProfileView === true) {
                                                    return (
                                                        <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                            {roleHeader}
                                                            {workTypeName && (
                                                                <span style={{ maxWidth: 120, overflowWrap: 'anywhere', fontWeight: 700 }}>
                                                                    {workTypeName}
                                                                </span>
                                                            )}
                                                        </span>
                                                    );
                                                }

                                                return (
                                                    <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                        {roleHeader}
                                                        <Tooltip title='Work Type' arrow>
                                                            <IconButton
                                                                size='small'
                                                                aria-label={`Select work type for ${column.label}`}
                                                                onClick={() => this.openWorkTypeDialog(role)}
                                                                sx={{
                                                                    color: 'inherit',
                                                                    padding: '2px',
                                                                    borderRadius: 1,
                                                                    fontWeight: 700,
                                                                    fontSize: 12,
                                                                    lineHeight: 1.2,
                                                                    maxWidth: '100%',
                                                                    minWidth: 0,
                                                                    whiteSpace: 'normal',
                                                                    textAlign: 'center',
                                                                    transition: 'transform 160ms ease, background-color 160ms ease',
                                                                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.16)', transform: 'translateY(-2px) scale(1.04)' },
                                                                    '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } },
                                                                }}
                                                            >
                                                                {workTypeName ? (
                                                                    <span style={{ maxWidth: 120, overflowWrap: 'anywhere', fontWeight: 700 }}>{workTypeName}</span>
                                                                ) : (
                                                                    <WorkIcon aria-hidden='true' sx={{ fontSize: 14, flexShrink: 0 }} />
                                                                )}
                                                            </IconButton>
                                                        </Tooltip>
                                                    </span>
                                                );
                                            })()
                                        ) : column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.length ? rows.map((row, index) => (
                                (() => {
                                    const rowKey = row.project_type_id ?? row.id ?? index;
                                    return (
                                        <TableRow
                                            hover
                                            key={rowKey}
                                            sx={{
                                                '&:nth-of-type(odd)': { backgroundColor: '#f0f7fa' },
                                                '& td': { transition: 'background-color 160ms ease, box-shadow 160ms ease' },
                                                '&:hover, &:hover td': { backgroundColor: '#e1f1f7' },
                                                '&:hover td:first-of-type': { boxShadow: 'inset 3px 0 0 #1682b5' },
                                                '@media (prefers-reduced-motion: reduce)': { '& td': { transition: 'none' } },
                                            }}
                                        >
                                            {columns.map(column => (
                                                <TableCell
                                                    key={column.field}
                                                    align={column.roleId !== undefined ? 'center' : 'inherit'}
                                                    sx={{
                                                        fontSize: 15,
                                                        whiteSpace: 'nowrap',
                                                        borderBottom: '1px solid #e3ebf0',
                                                        ...(column.stickyLeft !== undefined && {
                                                            position: 'sticky',
                                                            left: column.stickyLeft,
                                                            zIndex: 1,
                                                            width: column.width,
                                                            minWidth: column.width,
                                                            maxWidth: column.width,
                                                            backgroundColor: index % 2 === 0 ? '#f0f7fa' : '#fff',
                                                        }),
                                                    }}
                                                >
                                                    {column.field === 'select' ? (
                                                        <Radio
                                                            size='small'
                                                            checked={this.props.selectedImportProfileRow !== null
                                                                && this.props.selectedImportProfileRow !== undefined
                                                                && String(this.props.selectedImportProfileRow) === String(rowKey)}
                                                            onChange={() => this.props.handleProjectType(row, this.props.stageData)}
                                                            inputProps={{ 'aria-label': `Select ${row.project_type || 'resource profile row'}` }}
                                                        />
                                                    ) : column.field === 'actions' ? (
                                                        <span style={{ display: 'inline-flex', whiteSpace: 'nowrap' }}>
                                                            <IconButton
                                                                size='small'
                                                                aria-label='Edit row'
                                                                onClick={() => this.startRowEdit(row)}
                                                                sx={{ color: '#087e8b', transition: 'transform 160ms ease, background-color 160ms ease', '&:hover': { backgroundColor: 'rgba(8, 126, 139, 0.12)', transform: 'translateY(-2px) scale(1.08)' }, '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } } }}
                                                            >
                                                                <EditIcon fontSize='small' />
                                                            </IconButton>
                                                            {row.is_deletable === true && (
                                                                <IconButton
                                                                    size='small'
                                                                    aria-label='Delete row'
                                                                    disabled={this.state.deletingRowId === (row.project_type_id ?? row.id)}
                                                                    onClick={() => this.deleteRow(row)}
                                                                    sx={{ color: '#bd3c45', transition: 'transform 160ms ease, background-color 160ms ease', '&:hover': { backgroundColor: 'rgba(189, 60, 69, 0.12)', transform: 'translateY(-2px) scale(1.08)' }, '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } } }}
                                                                >
                                                                    <DeleteIcon fontSize='small' />
                                                                </IconButton>
                                                            )}
                                                        </span>
                                                    ) : column.roleId !== undefined
                                                        ? (() => {
                                                            const quantityData = row.qty?.find(item => String(item.role_id) === String(column.roleId));
                                                            const quantity = quantityData?.quantity;
                                                            const parsedQuantity = Number.parseFloat(quantity);
                                                            const formattedQuantity = Number.isFinite(parsedQuantity) ? parsedQuantity.toFixed(1) : '';
                                                            const cellKey = `${row.id ?? index}-${column.roleId}`;
                                                            const isEditing = !this.props.importProfileView && this.state.editingCell?.key === cellKey;

                                                            if (isEditing) {
                                                                return (
                                                                    <TextField
                                                                        autoFocus
                                                                        size='small'
                                                                        type='number'
                                                                        value={this.state.editValue}
                                                                        inputProps={{ step: '0.1', 'aria-label': `Edit ${column.label} quantity` }}
                                                                        onChange={event => this.setState({ editValue: event.target.value })}
                                                                        onKeyDown={event => {
                                                                            if (event.key === 'Enter') {
                                                                                this.handleQuantityEnter();
                                                                            } else if (event.key === 'Escape') {
                                                                                this.setState({ editingCell: null });
                                                                            }
                                                                        }}
                                                                        sx={{ width: 82 }}
                                                                    />
                                                                );
                                                            }

                                                            return (
                                                                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                                                                    {formattedQuantity}
                                                                    {!this.props.importProfileView && (
                                                                        <IconButton
                                                                            size='small'
                                                                            aria-label={`${formattedQuantity === '' ? 'Add' : 'Edit'} ${column.label} quantity`}
                                                                            onClick={() => this.setState({
                                                                                editingCell: {
                                                                                    key: cellKey,
                                                                                    rowId: row.id,
                                                                                    quantityId: quantityData?.id,
                                                                                    projectTypeId: row.project_type_id ?? row.id,
                                                                                    roleId: column.roleId,
                                                                                    isCreating: formattedQuantity === '',
                                                                                },
                                                                                editValue: formattedQuantity,
                                                                            })}
                                                                            sx={{ padding: '1px', width: 18, height: 18 }}
                                                                        >
                                                                            {formattedQuantity === ''
                                                                                ? <AddIcon sx={{ fontSize: 13 }} />
                                                                                : <EditIcon sx={{ fontSize: 13 }} />}
                                                                        </IconButton>
                                                                    )}
                                                                </span>
                                                            );
                                                        })()
                                                        : column.field === 'project_value'
                                                            ? formatValue(column.field, row[column.field] ?? '')
                                                            : row[column.field] ?? ''}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    );
                                })()
                            )) : (
                                <TableRow>
                                    <TableCell colSpan={columns.length}>
                                        <Typography align='center' color='text.secondary'>
                                            No resource profile data available
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Dialog
                    open={Boolean(this.state.deleteConfirmationRow)}
                    onClose={() => {
                        if (this.state.deletingRowId === null) {
                            this.setState({ deleteConfirmationRow: null });
                        }
                    }}
                    fullWidth
                    maxWidth='xs'
                    aria-labelledby='delete-resource-profile-row-title'
                >
                    <DialogTitle id='delete-resource-profile-row-title'>Delete Resource Profile Row</DialogTitle>
                    <DialogContent>
                        <Typography>Delete this resource profile row? This action cannot be undone.</Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color='secondary'
                            variant='contained'
                            disabled={this.state.deletingRowId !== null}
                            onClick={() => this.setState({ deleteConfirmationRow: null })}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant='contained'
                            style={{ backgroundColor: '#d32f2f', color: '#fff' }}
                            disabled={this.state.deletingRowId !== null}
                            onClick={() => this.confirmDeleteRow()}
                        >
                            {this.state.deletingRowId !== null ? 'Deleting...' : 'Delete'}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.workTypeDialogOpen}
                    onClose={() => this.closeWorkTypeDialog()}
                    fullWidth
                    maxWidth='xs'
                    aria-labelledby='select-work-type-title'
                >
                    <DialogTitle id='select-work-type-title'>Select Work Type</DialogTitle>
                    <DialogContent>
                        <Autocomplete
                            options={this.state.workTypeData}
                            getOptionLabel={option => option?.name || ''}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            value={this.state.selectedWorkType}
                            onChange={(event, value) => this.setState({ selectedWorkType: value })}
                            renderInput={params => (
                                <TextField
                                    {...params}
                                    autoFocus
                                    required
                                    label='Work Type'
                                    variant='outlined'
                                    margin='dense'
                                    fullWidth
                                    sx={{
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#9e9e9e',
                                            borderWidth: 1,
                                        },
                                        '&:hover .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#075e96',
                                        },
                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#075e96',
                                            borderWidth: 2,
                                        },
                                    }}
                                />
                            )}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.closeWorkTypeDialog()} disabled={this.state.submittingWorkType} sx={{ transition: 'transform 160ms ease', '&:hover': { transform: 'translateY(-1px)' }, '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } } }}>
                            Cancel
                        </Button>
                        <Button
                            onClick={() => this.submitWorkType()}
                            variant='contained'
                            color='primary'
                            disabled={this.state.submittingWorkType}
                            sx={{ boxShadow: '0 2px 6px rgba(7, 94, 150, 0.24)', transition: 'transform 160ms ease, box-shadow 160ms ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 5px 12px rgba(7, 94, 150, 0.32)' }, '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } } }}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={Boolean(this.state.editingRow)}
                    onClose={() => this.setState({ editingRow: null })}
                    fullWidth
                    maxWidth='xs'
                    aria-labelledby='edit-resource-profile-row-title'
                >
                        <DialogTitle id='edit-resource-profile-row-title'>Edit Resource Profile Row</DialogTitle>
                        <DialogContent>
                            <TextField
                                autoFocus
                                fullWidth
                                label='Project Type'
                                value={this.state.editProjectType}
                                onChange={event => this.setState({ editProjectType: event.target.value })}
                                margin='dense'
                                variant='outlined'
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#9e9e9e',
                                        borderWidth: 1,
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#075e96',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#075e96',
                                        borderWidth: 2,
                                    },
                                }}
                            />
                            <TextField
                                fullWidth
                                type='number'
                                label='Value'
                                value={this.state.editProjectValue}
                                onChange={event => this.setState({ editProjectValue: event.target.value })}
                                inputProps={{ min: 0, step: 'any' }}
                                margin='dense'
                                variant='outlined'
                                sx={{
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#9e9e9e',
                                        borderWidth: 1,
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#075e96',
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#075e96',
                                        borderWidth: 2,
                                    },
                                }}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.setState({ editingRow: null })} sx={{ transition: 'transform 160ms ease', '&:hover': { transform: 'translateY(-1px)' }, '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } } }}>Cancel</Button>
                            <Button onClick={event => this.saveRowEdit(event)} type='submit' variant='contained' color='primary' sx={{ boxShadow: '0 2px 6px rgba(7, 94, 150, 0.24)', transition: 'transform 160ms ease, box-shadow 160ms ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 5px 12px rgba(7, 94, 150, 0.32)' }, '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:hover': { transform: 'none' } } }}>Submit</Button>
                        </DialogActions>
                </Dialog>
            </>
        )
    }
}

export default withSnackbar(ResourceProfileTable);